import { render, staticRenderFns } from "./point-order-state-edit.vue?vue&type=template&id=177a2a50"
import script from "./point-order-state-edit.vue?vue&type=script&lang=js"
export * from "./point-order-state-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports